import React from 'react';
import ReactDOM from 'react-dom';
import registerServiceWorker from './registerServiceWorker';
import {Provider} from 'react-redux';
import MRouter from './routes/index-mobile';
import {store, persistor} from './store';
import {setInterceptors} from './utils/request';
import moment from 'moment';
import momentLocale from 'moment/locale/zh-cn';
import DevTools from "./components/DevTools";
import {PersistGate} from 'redux-persist/lib/integration/react'


setInterceptors(store);




moment.updateLocale('zh-cn', momentLocale)
const useDevTools = process.env.NODE_ENV === 'development';

const contentElement = useDevTools ?
    <div style={{height: " 100%"}}>
        <MRouter store={store}/>
        <DevTools/>
    </div>
    :
    <MRouter store={store}/>


const renderElement =
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            {contentElement}
        </PersistGate>
    </Provider>


ReactDOM.render(renderElement, document.getElementById('root'));
registerServiceWorker();





// WEBPACK FOOTER //
// ./src/index.js